import { TypeSitemap } from '@core/type';

export const DEFAULT_SITEMAP_PROPERTIES: TypeSitemap = {
  changefreq: 'weekly',
  priority: 1,
};
